import { useState, useEffect } from 'react'

interface RenderLabelProps {
  children: string
}

interface LanguageData {
  [key: string]: string
}

const RenderLabel: React.FC<RenderLabelProps> = ({ children }) => {
  const [label, setLabel] = useState<string>('')
  const [language, setLanguage] = useState<string>('')

  useEffect(() => {
    const storedLanguage = localStorage.getItem('lang') || 'en'
    setLanguage(storedLanguage)
  }, [])

  useEffect(() => {
    if (!language) return

    setLabel(children)

    const loadLabel = async () => {
      try {
        const labels = await import(`../../api/utils/lang/${language}.json`)
        const languageData = labels.default as LanguageData

        setLabel(languageData[children] || children)
      } catch (error) {
        console.error('Error loading language file:', error)
        setLabel(children)
      }
    }

    loadLabel()
  }, [children, language])

  return <div>{label}</div>
}

export default RenderLabel
